import type { EfteruddannelseIndberetningStatusId } from "@/api/person/paabud";

/**
 * Statusser hvor indberetningen regnes som modtaget fra advokaten. Spejler status-delen af
 * `PersonPaabudIndberetning.ErModtaget()` / `PersonPaalaegIndberetning.ErModtaget()` i
 * backenden.
 *
 * Backenden ser desuden på indberetningslinjer, registreringsdato og signatur, som ikke alle
 * er med i DTO'en. Derfor er den her et hjælpsomt gæt til fladen — ikke en garanti. Den rigtige
 * spærring ligger i domænet og svarer 400; formålet her er blot ikke at tilbyde en formular,
 * der ikke kan gemmes.
 */
const MODTAGNE_STATUSSER: EfteruddannelseIndberetningStatusId[] = [
  "ModtagetUdenFejl",
  "ModtagetMedFejl",
  "Undersoeges",
  "IndbragtForAdvokatnaevnet",
  "Henlagt",
];

/** Er afgørelsens indberetning modtaget, så afgørelsen ikke længere kan redigeres? */
export const erIndberetningModtaget = (
  status: EfteruddannelseIndberetningStatusId | null | undefined,
): boolean => (status ? MODTAGNE_STATUSSER.includes(status) : false);
